import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@pages/dashboard';

/** Dashboard-Übersicht-Route (/) */
export const Route = createFileRoute('/_authenticated/')({
  component: DashboardPage,
});
